import React from 'react'
import "./AddProducts.css"
import { NavLink } from 'react-router-dom'
function AllProducts() {
  return (
    <>
        <div class="all-productsbody">
  <section class="morara-shop-grid">

    <div class="morara-cardd">
      <img src="https://i.pinimg.com/1200x/91/57/7d/91577de54c5fbd65f292d08cde9b74f2.jpg" alt="Art Deco Home" />

      <div class="morara-card-info">
        <h3>Choose Morara</h3>
        <p>Choose The Best</p>
      </div>
    </div>

    <div class="morara-cardd wide">
      <img src="https://i.pinimg.com/1200x/5e/c9/6e/5ec96e543a777e1210fec581918e487a.jpg" alt="Helen Chair" />
    <NavLink className="navlinkk" to="/sofas">

      <div class="morara-card-info">
        <h3>Premium Sofas</h3>
        <p>Explore</p>
      </div>
    </NavLink>

    </div>

    <div class="morara-cardd company">

      <div class="morara-card-info">
        <h3>Morara Furnitures</h3>
        <p>Simply The Best</p>
      </div>
    </div>


    <div class="morara-cardd">
      <img src="https://i.pinimg.com/736x/84/33/8e/84338ec2af8598c9a3a29c6a7b3e73d7.jpg" alt="Wood Eggs" />
    <NavLink className="navlinkk" to="/tables">

      <div class="morara-card-info">
        <h3>Dining Tables</h3>
        <p>Explore</p>
      </div>
    </NavLink>

    </div>


    <div class="morara-cardd wide">
      <img src="https://i.pinimg.com/736x/11/70/ec/1170ec10eb74b5a7616ad1713c4df4b4.jpg" alt="Table Wood Pine" />
    <NavLink className="navlinkk" to="/beds">
      
      <div class="morara-card-info">
        <h3>Premium Beds</h3>
        <p>Explore</p>
      </div>
    </NavLink>

    </div>


  </section>
  </div>
    </>
  )
}

export default AllProducts
